<template>
    <div
        class="reactivation-warning"
        data-qa="reactivation-warning"
    >
        <DsInlineAlert leading-icon type="warning">
            <template #default>
                <p
                    class="reactivation-sentence"
                    data-qa="reactivation-sentence"
                >
                    {{ reactivationNoticeSentence }}

                    <a
                        class="contact-support-link"
                        data-qa="contact-support-link"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="contactSupportLink"
                    >
                        {{ $t('myaccount.quick.add.change.summary.confirm.error.contact.support') }}
                    </a>
                    {{ $t('myaccount.quick.add.change.summary.confirm.error.remove.cancellation.reactivate.plan') }}
                </p>
            </template>
        </DsInlineAlert>
    </div>
</template>

<script>
import moment from 'moment/moment';

const CONTACT_SUPPORT_LINK = 'https://help.infusionsoft.com/help/chat-status';

export default {
    props: {
        nextTermRenewalDate: String,
    },

    data() {
        return {
            contactSupportLink: CONTACT_SUPPORT_LINK,
        };
    },

    computed: {
        reactivationNoticeSentence() {
            return this.$t('myaccount.quick.add.non.active.subscription', { date: this.dateFormatDate(this.nextBillingDate) });
        },
    },

    methods: {
        dateFormatDate(date, format = 'll') {
            const formattedDate = moment.utc(date).isValid() ? date : new Date(date);

            return moment(formattedDate).format(format);
        },
    },
};
</script>

<style lang="scss" scoped>
.reactivation-warning {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
</style>
